import { api } from "../api";
import { DashboardTrackingResponseType } from "../../../types/types";

const findTrackingData = async (token: string, managerId: number, customerId: number | null = null) => {
    const response = await api.get<DashboardTrackingResponseType>(
        `/dashboard/${managerId}/tracking${customerId ? `?customerId=${customerId}` : ""}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findTrackingData;
